import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
// import Header from "../components/container/layout/client/Header";
import BusinessHeader from "../components/container/layout/business/Header";
import BusinessUserHeader from "../components/container/layout/business_user/Header";
// import BusinessUserSideBar from "../components/container/SideBar";
// import ClientSideBar from "../components/container/layout/client/SideBar";
// import FooterSection from "../components/UI/FooterSection";
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";

import { getTimeoutbycategory } from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';

import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';


function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}
const emrFeatures = [
    { title: "Elevate Teleconsultation", description: "Connect with patients remotely with seamless and secure teleconsultation capabilities.", imageSrc: require("../../src/assets/images/website/product4.png") },
    { title: "Instant Patient Records Access", description: "Access comprehensive medical records instantly, allowing for faster and more informed decisions. ", imageSrc: require("../../src/assets/images/website/product3.png") },
    { title: "Specialty-Based Assessments simplified", description: "Quickly generate detailed diagnosis reports with easy-to-use assessment screens and drop-down options. ", imageSrc: require("../../src/assets/images/website/product1.png") },
    { title: "Seamless Physician Referrals", description: "Facilitate efficient referrals to specialists with just a few clicks.", imageSrc: require("../../src/assets/images/website/product5.png") }
  ];

  
  const defaultImage = require("../../src/assets/images/website/product4.png"); // Set default image
  
 

class KlinicqBenifits extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
            selectedImage: defaultImage, 
            
            // selectedImages: require("../../src/assets/images/website/imagebg.png"),
      defaultImages: require("../../src/assets/images/website/product4.png"),
      telehealthFeatures: [
        { title: "Automated Follow-Up Reminders", description: "Set up patient follow-up reminders with ease, ensuring timely care and improved adherence.", imageSrc: require("../../src/assets/images/website/product1.png") },
        { title: "Enhanced Communication with Pharmacies", description: "Send prescriptions directly to pharmacies, ensuring accuracy and speed.", imageSrc: require("../../src/assets/images/website/product3.png") },
        { title: "Rapid Digital Prescribing", description: "Quickly create accurate prescriptions with our user-friendly database and drop-down options.", imageSrc: require("../../src/assets/images/website/product4.png") },
        { title: "Computerized Handwritten Prescriptions", description: "Transform handwritten notes into digital prescriptions with a simple click.", imageSrc: require("../../src/assets/images/website/product5.png") },
      ],
      hoveredFeature: null
            
        }   
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }
    handleFeatureHover = (feature) => {
        this.setState({ selectedImage: feature.imageSrc }); // Change image on hover
        this.setState({ selectedImages: feature.imageSrc, hoveredFeature: feature });
  };
    
      handleFeatureLeave = () => {
        this.setState({ selectedImage: defaultImage }); // Revert back to default image
        this.setState({ selectedImages: this.state.defaultImages, hoveredFeature: null });
      };
    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        return (
            <div className="">
              <Helmet>
                    <title>Benefits | KlinicQ</title>
                    <meta 
                        name="description" 
                        content="Discover the benefits of KlinicQ, from increased ROI to better patient care. Our management system helps clinics reduce wait times and streamline operations." 
                    />
                   < script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Benefits",
      "url": "https://www.klinicq.com/klinicqbenifits",
      "isPartOf": {
        "@type": "WebSite",
        "name": "KlinicQ",
        "url": "https://www.klinicq.com"
      }
    })}
  </script>
                </Helmet>

                <div className="">
                    
                    <div className="">
                       
<div className='product-section'>
    <Headerweb/>
         {/* <hr className='m-0' style={{ color: '#D9F4FF' }} /> */}

    <section className="hero-sectionbenifits">
      <div className="overlap-wrapper">
        <div className="overlap">
          <div className="overlap-group">
            <div className="ellipse" aria-hidden="true"></div>
            <div className="group">
              <div className="image-container">
                <div className="ellipse-2" aria-hidden="true"></div>
                {/* <img
                  class="frame"
                  src={require("../../src/assets/images/website/benifits star.png")}
                  alt=""
                  aria-hidden="true"
                /> */}
                <img
                  class="doctor-image"
                  src={require("../../src/assets/images/website/healthcare-software-benefits.webp")}
                  alt="Doctor using clinic management software to optimize operations and increase revenue"
                />
              </div>
            </div>
            <div className="ellipse-3" aria-hidden="true"></div>
            <div className="ellipse-4" aria-hidden="true"></div>
            <div className="ellipse-5" aria-hidden="true"></div>
            <div className="increase-revenue" aria-hidden="true">OPTIMIZE OPERATIONAL</div>
            <div className="text-wrapper" aria-hidden="true">INCREASE REVENUE</div>
            <div className="increase-revenue-2" aria-hidden="true">EXPENSES</div>
            <img className="vector" src={require("../../src/assets/images/website/diagram.webp")} alt="" aria-hidden="true" />
            <img class="img" src={require("../../src/assets/images/website/Benifits8.webp")} alt="" aria-hidden="true" />
          </div>
          <div className="overlap-2">
            <div className="ellipse-6" aria-hidden="true"></div>
            <div className="rectangle" aria-hidden="true"></div>
            <div className="rectangle-2" aria-hidden="true"></div>
            <div className="rectangle-3" aria-hidden="true"></div>
            <section className="content-group">
              <h1 className="main-heading">Optimize operational &amp; expenses &amp; increase revenue</h1>
              <p className="description">
                KlinicQ helps clinics run smoothly, save money, and earn more by automating appointments and offering expert care online.
              </p>
              <div className="cta-group">
                <a href="/webcontact" class="cta-button primary">
                  <span className="cta-text">BOOK A DEMO</span>
                  <img
                    className="cta-icon"
                    src={require("../../src/assets/images/website/headphone-benifits.webp")}
                    alt=""
                    aria-hidden="true"
                  />
                </a>
                <a href="/webcontact" className="cta-button secondary">CONTACT US</a>
              </div>
            </section>
            <img
              className="frame-3"
              src={require("../../src/assets/images/website/ellipse 3.webp")}
              alt=""
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </section>
       
            <section className=''>
           

    <div className="container-80 mt-5">
  <div className="grid-row">
    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle">1</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/benifits-doctor-1000.webp")} alt="Doctor providing teleconsultation using digital healthcare platform" />
        </div>
      </div>
      <div className="title-description">
        <h3>Elevate Tele Consultation</h3>
        <p>Connect with patients remotely with seamless and secure tele-consultation capabilities.</p>
      </div>
    </div>

    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle1">2</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/subtract 2.webp")} alt="Instant access to patient medical records in clinic management software" />
        </div>
      </div>
      <div className="title-description">
        <h3>Instant Patient Records Access</h3>
        <p>Access comprehensive medical records instantly, allowing for faster and more informed decisions.</p>
      </div>
    </div>

    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle2">3</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/subtract 1.webp")} alt="Specialty based medical assessment and diagnosis report interface" />
        </div>
      </div>
      <div className="title-description">
        <h3>Specialty-Based Assessments Simplified</h3>
        <p>Quickly generate detailed diagnosis reports with easy-to-use assessment screens and dropdown options.</p>
      </div>
    </div>
  </div>

  <div className="grid-row">
    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle">4</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/subtract 3.webp")} alt="Streamlined healthcare billing and invoicing system dashboard" />
        </div>
      </div>
      <div className="title-description">
        <h3>Streamlined Billing System</h3>
        <p>Simplify financial transactions with an integrated billing system designed for healthcare.</p>
      </div>
    </div>

    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle1">5</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/subtract 4.webp")} alt="AI powered healthcare analytics and personalized health insights" />
        </div>
      </div>
      <div className="title-description">
        <h3>AI-Powered Health Insights</h3>
        <p>Leverage AI-driven analytics to provide personalized health insights and treatment suggestions.</p>
      </div>
    </div>

    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle2">6</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/subtract 5.webp")} alt="Secure patient data management with encrypted medical records" />
        </div>
      </div>
      <div className="title-description">
        <h3>Secure Patient Data Management</h3>
        <p>Ensure privacy and security with encrypted medical data storage and controlled access.</p>
      </div>
    </div>
  </div>
</div>
   
 <div className='single-click py-5'>
          <div className='container'>
            <div className='row m-0'>
              {/* <div className='col-lg-4 col-12 mb-lg-0 mb-3 slide-left visible'>
                
              </div> */}
              <div className='col-lg-12 col-12 py-lg-0 py-md-0 py-2 slide-right visible text-center'>

              <h3>Expert Care, Anytime, Anywhere </h3>
                <p>Experience healthcare on your terms. Access licensed doctors instantly for personalized advice and seamless health management, wherever you are. Say goodbye to waiting rooms and rigid appointments – your health is now in your hands.</p>
              </div>
                     <div className="image-container1">
    {/* <img src={require("../../src/assets/images/website/Rectangle19.png")} className="background-image1" alt="Background" /> */}
   <img
  src={require("../../src/assets/images/website/Group76-1200.webp")}
  srcSet={`
    ${require("../../src/assets/images/website/Group76-768.webp")} 768w,
    ${require("../../src/assets/images/website/Group76-1200.webp")} 1200w,
    ${require("../../src/assets/images/website/Group76-1600.webp")} 1600w
  `}
  sizes="(max-width: 1200px) 100vw, 1053px"
  className="foreground-image1"
  alt="Online doctor consultation platform for expert care anytime anywhere"
  loading="lazy"
/>

</div>
            </div>
          </div>
        </div>
        <div>
          </div>
              
            </section>
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
 
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(KlinicqBenifits);